export const goodsRedeemTypesEnum = {
    ONLINE: { code : 1, type : "线上"},
    OFFLINE: { code : 2, type : "线下"},
    VIRTUAL: { code : 3, type : "虚拟"},
    PHYSICAL_EXCHANGE: { code : 4, type : "实物兑换"},
}

export const memberGoodsStatusEnum = {
    LOCKED: { code : 1, status : "已锁定"},
    HAS_CHANGED: { code : 2, status : "已兑换"},
    USED: { code : 3, status : "已使用"},
    EXPIRED: { code : 4, status : "已过期"},
    EXCHANGE_FAIL: { code : 5, status : "兑换失败"},
    NO_DELIVERED: { code : 6, status : "待发货"},
    DELIVERED: { code : 7, status : "已发货"},
    CONFIRM_RECEIPT: { code : 8, status : "已确认收货"},            
}